import React from 'react'
// import Img from 'gatsby-image'
import { GatsbyImage } from 'gatsby-plugin-image'
import styled from '@emotion/styled'
// import {getFluidGatsbyImage} from 'gatsby-source-sanity'
import {getGatsbyImageData} from 'gatsby-source-sanity'
import clientConfig from '../../client-config'

import theme from '../utils/theme';
import {Figcaption} from '../utils/styles'

const Figure = styled('figure')`
  margin: 50px 0 50px 0;

  @media ${theme.breakpoints.md} { 
    max-width: 80%;
    margin: 50px auto 50px;
  }
`
export default ({node}) => {
  if (!node || !node.asset || !node.asset._id) { return null }
  const imageData = getGatsbyImageData(node.asset._id, {maxWidth: 675}, clientConfig.sanity)

  return (
    <Figure>
      <GatsbyImage image={imageData} alt={node.alt} />
      <Figcaption>{node.caption}</Figcaption>
    </Figure>
  )
}